let deferredPrompt: any = null
const callback: ((canInstall: boolean) => void)[] = []

window.addEventListener('beforeinstallprompt', (e) => {
  deferredPrompt = e
  // 触发可以安装的事件
  for (let i = 0; i < callback.length; i++) {
    callback[i](true)
  }
})

export function listenCanInstall (cb: (canInstall: boolean) => void) {
  callback.push(cb)
}

export function install () {
  deferredPrompt.prompt()
  deferredPrompt.userChoice.then((choiceResult: any) => {
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the A2HS prompt')
      deferredPrompt = null
      for (let i = 0; i < callback.length; i++) {
        callback[i](false)
      }
    } else {
      console.log('User dismissed the A2HS prompt')
    }
  })
}
